module.exports = __webpack_public_path__ + "static/media/view1.ace8449d.jpg";